import React from 'react';
import style from './style.scss';
import {AddFairProduct} from './sub-view/fair';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessAddFairProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <BusinessLayout active='business-fair'>
        <AddFairProduct edit={this.props.edit}/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessAddFairProduct;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessAddFairProduct.jsx